import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/map.svg'


const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = { class: "trezo-card-subtitle" }
const _hoisted_6 = { class: "trezo-card-dropdown relative" }
const _hoisted_7 = { class: "trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[10000] dark:bg-dark dark:shadow-none" }
const _hoisted_8 = { class: "trezo-card-content" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center justify-center min-h-[160px]"
}
const _hoisted_10 = {
  class: "animate-spin inline-block w-8 h-8 border-[3px] border-current border-t-transparent text-primary-500 rounded-full",
  role: "status",
  "aria-label": "loading"
}
const _hoisted_11 = { class: "sr-only" }
const _hoisted_12 = {
  key: 1,
  class: "flex items-center justify-center min-h-[160px]"
}
const _hoisted_13 = { class: "text-center text-gray-400 dark:text-gray-500" }
const _hoisted_14 = { class: "mt-[20px]" }
const _hoisted_15 = { class: "shrink-0 ltr:mr-[15px] rtl:ml-[15px]" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = { class: "grow" }
const _hoisted_18 = { class: "flex justify-between" }
const _hoisted_19 = { class: "block font-medium mb-[2px]" }
const _hoisted_20 = { class: "text-sm text-gray-500" }
const _hoisted_21 = { class: "leading-none flex items-center" }
const _hoisted_22 = { class: "flex w-full h-[4px] overflow-hidden rounded-md bg-primary-50 dark:bg-[#172036]" }
const _hoisted_23 = { class: "block ltr:ml-[15px] rtl:mr-[15px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.directT('dashboard.salesByLocations')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass({
              'trezo-card-dropdown-btn inline-block transition-all text-[26px] text-gray-500 dark:text-gray-400 leading-none hover:text-primary-500': true,
              active: _ctx.isActive,
            }),
            id: "dropdownToggle",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleActive && _ctx.toggleActive(...args)), ["stop"]))
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "ri-more-fill" }, null, -1)
          ]), 2),
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectPeriod('day'))),
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, _toDisplayString(_ctx.directT('dashboard.thisDay')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectPeriod('week'))),
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, _toDisplayString(_ctx.directT('dashboard.thisWeek')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectPeriod('month'))),
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, _toDisplayString(_ctx.directT('dashboard.thisMonth')), 1)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectPeriod('year'))),
                class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black"
              }, _toDisplayString(_ctx.directT('dashboard.thisYear')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.directT('common.loading') || 'Loading...'), 1)
            ])
          ]))
        : (_ctx.countries.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.directT('common.noData') || 'No data available'), 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex items-center justify-center min-h-[160px]" }, [
                _createElementVNode("div", { class: "text-center" }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: "map"
                  })
                ])
              ], -1)),
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "flex items-center mb-[15px] last:mb-0",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: _ctx.getFlagImagePath(country.image),
                        class: "inline-block w-[24px] h-[24px] rounded-full object-cover",
                        alt: country.name
                      }, null, 8, _hoisted_16)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, _toDisplayString(country.name), 1),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatCurrency(country.amount)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", {
                            class: "flex flex-col justify-center overflow-hidden bg-primary-500 rounded-md",
                            style: _normalizeStyle({ width: country.progress + '%' })
                          }, null, 4)
                        ]),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(country.progress) + "% ", 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ], 64))
    ])
  ]))
}